import type { RefObject } from 'react'
import { InterviewStatus } from '@bosmart/types'
import { ErrorOverlay } from './ErrorOverlay'
import { NotificationToast } from './NotificationToast'
import { ReadyOverlay } from './ReadyOverlay'
import { SessionPrompts } from './SessionPrompts'

interface VideoGridProps {
  videoRef: RefObject<HTMLVideoElement>
  pipVideoRef: RefObject<HTMLVideoElement>
  canvasRef: RefObject<HTMLCanvasElement>
  isScreenSharing: boolean
  showStartCue: boolean
  showSpeakFirstPrompt: boolean
  showThankYou: boolean
  notification: string | null
  error: string | null
  hasLiveService: boolean
  status: InterviewStatus
  onStart: () => void
  onReload: () => void
}

export function VideoGrid({
  videoRef,
  pipVideoRef,
  canvasRef,
  isScreenSharing,
  showStartCue,
  showSpeakFirstPrompt,
  showThankYou,
  notification,
  error,
  hasLiveService,
  status,
  onStart,
  onReload,
}: VideoGridProps) {
  return (
    <div
      className={`flex-1 relative flex items-center justify-center bg-black transition-all duration-300 ${isScreenSharing ? 'border-4 border-accent-500/30' : ''}`}
    >
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        className="w-full h-full object-cover opacity-90"
      />
      <canvas ref={canvasRef} className="hidden" />

      {isScreenSharing && (
        <div className="absolute top-20 right-4 w-48 h-36 bg-black rounded-xl border-2 border-brand-500/40 shadow-2xl overflow-hidden z-40 animate-fade-in-up">
          <video
            ref={pipVideoRef}
            autoPlay
            playsInline
            muted
            className="w-full h-full object-cover scale-x-[-1]"
          />
          <div className="absolute bottom-1 left-2 text-[10px] font-medium text-white/90 bg-brand-600/80 px-2 py-0.5 rounded shadow-sm">
            You (Camera)
          </div>
        </div>
      )}

      <SessionPrompts
        showStartCue={showStartCue}
        showSpeakFirstPrompt={showSpeakFirstPrompt}
        isScreenSharing={isScreenSharing}
        showThankYou={showThankYou}
      />
      <NotificationToast message={notification} />
      <ReadyOverlay
        hasLiveService={hasLiveService}
        hasError={!!error}
        status={status}
        onStart={onStart}
      />
      <ErrorOverlay error={error} onReload={onReload} />
    </div>
  )
}
